import * as yup from 'yup'

export const adminCounselSchema = yup.object().shape({
    title: yup.string().required('제목을 입력하세요'),
    date: yup.string().required('작성일을 입력하세요'),
    content: yup.string().required('내용을 입력하세요'),
    // files: yup.mixed().test('fileSize', '파일 크기는 5MB 이하만 가능합니다', (value) => {
    //     return value.length === 0 || (value[0] && value[0].size <= 5 * 1024 * 1024);
    // }),
});
